import {
  ConsentPolicyType,
  ConsentStatus,
  PolicyConsentStatus
} from 'interfaces/consent-status.interface';

export const getOutdatedPolicies = (status: ConsentStatus) =>
  (
    Object.entries(status.policies) as [
      ConsentPolicyType,
      PolicyConsentStatus
    ][]
  ).filter(([, policy]) => policy.requires_consent);
